import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className='privacy-policy-title'>
            <div className="privacy-policy-title-container">
            <h1>Privacy Policy</h1>
            </div>
        <div className="privacy-policy">
            <p>Last updated: 8/27/2023</p>
            <p>This page informs you of our policies regarding the collection, use, and disclosure of personal information we receive from users of the site.
                We use your Personal Information only for providing and improving the Site. By using the Site, you
                agree to the collection and use of information in accordance with this policy.</p>
            <h3>Information Collection And Use</h3>
            <p><b><i>Log Data</i></b></p> <br />
                <p>Like many site operators, we collect information that your browser sends whenever you visit our site. This information is only used for analytic awareness.
                This Log Data may include information such as your computer's Internet Protocol ("IP") address,
                browser type, browser version, the pages of our Site that you visit, the time and date of your visit,
                the time spent on those pages and other statistics.</p>
            <h3>AFFILIATE DISCLOSURE</h3>
            <p>When you click on links on the website, I make generate a commission. None of the reviews are paid for beforehand, and every VPN review is objective. </p>
        </div>
        </div>
    );
}

export default PrivacyPolicy;